import { render } from "./KaskoForm.vue?vue&type=template&id=433b9582&scoped=true"
import script from "./KaskoForm.vue?vue&type=script&lang=js"
export * from "./KaskoForm.vue?vue&type=script&lang=js"

import "./KaskoForm.vue?vue&type=style&index=0&id=433b9582&scoped=true&lang=css"

import exportComponent from "/workspace/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-433b9582"]])

export default __exports__